import React from 'react'
import EntityRow from './EntityRow'
import * as entityHeading from '../../../Constants/Constants'
import Style from '../manageEntities.module.css'

const StateBlock = ({ children }) => <div className={Style.stateBlock}>{children}</div>

/**
 * Header and rows share one table now. They used to be two tables stacked with a
 * negative offset and a hard coded first column width, which drifted out of
 * alignment as soon as an entity name got long.
 */
const EntityList = ({
    entities,
    totalCount,
    isLoading,
    loadError,
    savingId,
    searchTerm,
    onToggle,
    onRetry,
    onClearSearch
}) => {
    if (isLoading) {
        return (
            <StateBlock>
                <span className={Style.inlineSpinner} aria-hidden="true" />
                <p className={Style.stateText}>Loading entities...</p>
            </StateBlock>
        )
    }

    if (loadError) {
        return (
            <StateBlock>
                <i className={`uil-exclamation-octagon ${Style.stateIconError}`} aria-hidden="true" />
                <p className={Style.stateText}>{loadError}</p>
                <button type="button" className={Style.retryButton} onClick={onRetry}>
                    Try again
                </button>
            </StateBlock>
        )
    }

    if (totalCount === 0) {
        return (
            <StateBlock>
                <i className={`uil-database ${Style.stateIcon}`} aria-hidden="true" />
                <p className={Style.stateText}>No entities available</p>
                <p className={Style.stateHint}>They appear once the connector setup is complete.</p>
            </StateBlock>
        )
    }

    if (entities.length === 0) {
        return (
            <StateBlock>
                <i className={`uil-search ${Style.stateIcon}`} aria-hidden="true" />
                <p className={Style.stateText}>No entity matches &quot;{searchTerm}&quot;</p>
                <button type="button" className={Style.retryButton} onClick={onClearSearch}>
                    Clear search
                </button>
            </StateBlock>
        )
    }

    return (
        <div className={Style.tableScroll}>
            <table className={Style.table}>
                <thead>
                    <tr>
                        <th scope="col">{entityHeading.entityHeading.entityName}</th>
                        <th scope="col">{entityHeading.entityHeading.targetToSource}</th>
                        <th scope="col">{entityHeading.entityHeading.sourceToTarget}</th>
                    </tr>
                </thead>
                <tbody>
                    {entities.map((entity) => (
                        <EntityRow
                            key={entity.id}
                            entity={entity}
                            isSaving={savingId === entity.id}
                            onToggle={onToggle}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default EntityList
